import type { SVGProps } from 'react';
const DawnFlagSB = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-SB_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-SB_svg__a)">
      <path fill="url(#dawn-flag-SB_svg__b)" d="M0 0h22v16H0z" />
      <g filter="url(#dawn-flag-SB_svg__c)">
        <path
          fill="url(#dawn-flag-SB_svg__d)"
          fillRule="evenodd"
          d="M0 0h22L0 16z"
          clipRule="evenodd"
        />
      </g>
      <path fill="#2C7442" fillRule="evenodd" d="M22 0 0 16h22z" clipRule="evenodd" />
      <path fill="#FFD646" d="M-2.18 15.765 19.672.757l10.471 15.807L8.291 31.57z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m1.587 3.479.147-.873-.623-.618.86-.127.386-.794.385.794.86.127-.623.618.147.873-.77-.412zm6.008-.412-.77.412.147-.873-.623-.618.861-.127.385-.794.385.794.86.127-.622.618.147.873zm-.77 3.612.77-.412.77.412-.147-.873.622-.618-.86-.127-.385-.794-.385.794-.86.127.622.618zm-5.238 0 .147-.873-.623-.618.86-.127.386-.794.385.794.86.127-.623.618.147.873-.77-.412zm2.62-1.6.769-.412.77.412-.147-.873.622-.618-.86-.127-.385-.794-.385.794-.86.127.622.618z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-SB_svg__b"
        x1={0}
        x2={0}
        y1={0}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1DBE4F" />
        <stop offset={1} stopColor="#159B3F" />
      </linearGradient>
      <linearGradient
        id="dawn-flag-SB_svg__d"
        x1={0}
        x2={0}
        y1={0}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0660D4" />
        <stop offset={1} stopColor="#0051BB" />
      </linearGradient>
      <filter
        id="dawn-flag-SB_svg__c"
        width={22}
        height={16}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_1588" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_1588" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagSB;
